import { Children } from "react";

import { isEditing } from "@builder.io/sdk-react";
import classNames from "classnames";

import { Placeholder } from "../Placeholder/Placeholder";

import styles from "./Section.module.scss";

export function Section({ children }: { children: React.ReactNode }) {
  if (isEditing() && Children.count(children) === 0) {
    return <Placeholder>Drag and drop component here</Placeholder>;
  }

  return <section className={classNames(styles.section)}>{children}</section>;
}
